<div class="supportTicketForm">
  <div class="header-section">
    <h2>Create support ticket</h2>
  </div>
    <form [formGroup]="supportTicketForm" (ngSubmit)="onSubmit()">
      <div class="body-section">
        <div class="flex">
          <div class="p-fluid p-field col-6">
            <label for="subject">Subject<span class="red px-1">*</span></label>
            <input type="text" id="subject" formControlName="subject" class="p-inputtext">
          </div>
          <div class="p-fluid p-field col-6">
            <label for="email">Email<span class="red px-1">*</span></label>
            <input type="email" id="email" formControlName="email" class="p-inputtext">
          </div>
        </div>
        <div class="p-fluid p-field col-12">
          <label for="description">Description:</label>
          <textarea id="description" formControlName="description" class="p-inputtextarea p-6"></textarea>
        </div>
        <div class="flex flex-column gap-2 align-items-end justify-content-end">
          <p-fileUpload #uploader (onSelect)="onSelect($event, uploader)" [auto]="true" [chooseIcon]="null"
                        [maxFileSize]="1000000"
                        [chooseLabel]="supportTicketForm.value?.file ? 'Update File' : 'Upload File'" mode="basic" name="demo[]"
                        styleClass="change-img-btn sup-upload-image"></p-fileUpload>
          <span *ngIf="supportTicketForm.value?.file">Selected File: {{fileName}}</span>
        </div>
      </div>
      <div class="footer-section">
        <div class="flex align-items-center justify-content-end">
          <button type="submit" [disabled]="supportTicketForm.invalid" class="p-button p-button-primary">Submit</button>
        </div>
      </div>
    </form>
</div>



